module.exports = __webpack_public_path__ + "static/img/002城市名片1.d867e4d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/002城市名片1.jpg
// module id = IBvI
// module chunks = 0